import { BaseAPIModel } from '../shared/api.model';

declare const Object: any;

export interface AccountInterface {
  name: string;
  email: string;
  ticket?: object;
}

export class Account extends BaseAPIModel implements AccountInterface {
  name: string;
  email: string;
  ticket?: object;


  public static getModelName() {
    return 'Account';
  }

  public static factory(data: Account): Account {
    return new Account(data);
  }

}



// WEBPACK FOOTER //
// ./src/app/models/account.ts